<template>
  <pt-claim-lifeban class="pt-claim-lifeban__withData" :authCoolie="authCoolie" @getLoginDaishu="getLoginDaishu" :loading="loading" :externalType="externalType"></pt-claim-lifeban>
</template>

<script>
import PtClaimLifeban from './index'
export default {
  name: 'pt-claim-lifeban__withData',
  components: {
    'pt-claim-lifeban': PtClaimLifeban
  },
  data () {
    return {
      authCoolie: '',
      loading: false
    }
  },
  computed: {
    externalType () {
      return (this.$route.query && this.$route.query.externalType) || null
    }
  },
  methods: {
    getLoginDaishu () {
      this.loading = true
      this.$store.dispatch('insuranceClaimsLogin').then(res => {
        this.loading = false
        this.authCoolie = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取用户cookie失败')
      })
    }
  },
  created () {
    if (this.externalType) {
      this.getLoginDaishu()
    }
  }
}
</script>
